import {
    PATH_IDENTITY,
    PATH_IDENTITY_VIDEOCALL_CALLCENTER,
    PATH_IDENTITY_VIDEOCALL_FINISHED,
    PATH_IDENTITY_VIDEOCALL_START,
    PATH_IDENTITY_VIDEOSELFIE_CALLCENTER,
    PATH_IDENTITY_VIDEOSELFIE_FINISHED,
    PATH_IDENTITY_VIDEOSELFIE_START,
} from 'constants/uTagConstants/paths';
import cryptoJS from 'crypto-js';
import {
    EVENT_CALLCENTER_KO,
    EVENT_NAME,
    EVENT_VIDEOCALL_FINISHED,
    EVENT_VIDEOCALL_START,
    EVENT_VIDEOSELFIE_FINISHED,
    EVENT_VIDEOSELFIE_START,
    PROCESS_STEP,
    TEALIUM_IDENTITY_NAME,
} from 'routes/formsView/IdentityVerificationView/constants';
import { keyAndValueOrNull } from 'utilities/objectHelpers';
import { recordPage, RELIABLE } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import { getGA4EventKeys } from 'utilities/ga4';

const buildTagging = ({ userProfile, productsDescription }) => {
    const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    const { investmentType, identityMethod, identityStatus, recordId, userId, product, promoCode, docNumber } =
        userProfile;

    const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
    const reliableId = RELIABLE[identityMethod];
    const identityName = TEALIUM_IDENTITY_NAME[reliableId];

    const doTagRecordPageEvent = ({ path }) => {
        const customEventsMapper = {
            [PATH_IDENTITY_VIDEOCALL_START]: EVENT_VIDEOCALL_START,
            [PATH_IDENTITY_VIDEOCALL_FINISHED]: EVENT_VIDEOCALL_FINISHED,
            [PATH_IDENTITY_VIDEOSELFIE_START]: EVENT_VIDEOSELFIE_START,
            [PATH_IDENTITY_VIDEOSELFIE_FINISHED]: EVENT_VIDEOSELFIE_FINISHED,
            [PATH_IDENTITY_VIDEOCALL_CALLCENTER]: EVENT_CALLCENTER_KO,
            [PATH_IDENTITY_VIDEOSELFIE_CALLCENTER]: EVENT_CALLCENTER_KO,
        };
        const customUtagOptions = customEventsMapper[path] || null;

        recordPage(
            path,
            recordId,
            userId,
            product,
            productsDescription,
            promoCode ?? '',
            JointHolderInfo,
            reliableId,
            '',
            investmentType,
            {
                ...getGA4EventKeys({
                    eventName: EVENT_NAME,
                    pageName: `/onboarding/${PROCESS_STEP}/${identityName}/${identityStatus}`,
                    processDetail: `${identityName}/${identityStatus}`,
                    onboardingType: investmentType,
                }),
                ...customUtagOptions,
                identificadorOnboarding: docNumberEncrypted,
                processStep: PROCESS_STEP,
            }
        );

        return path;
    };

    const doTagRecordPage = identityMethod => {
        const reliableId = RELIABLE[identityMethod];
        const identityName = TEALIUM_IDENTITY_NAME[reliableId];
        const customData = {
            ...keyAndValueOrNull({ key: 'metodoDefecto', value: reliableId }),
            ...getGA4EventKeys({
                eventName: EVENT_NAME,
                pageName: `/onboarding/${PROCESS_STEP}/${identityName}`,
                processDetail: identityName,
                onboardingType: investmentType,
            }),
            identificadorOnboarding: docNumberEncrypted,
            processStep: PROCESS_STEP,
        };

        recordPage(
            PATH_IDENTITY,
            recordId,
            userId,
            product,
            productsDescription,
            promoCode ?? '',
            JointHolderInfo,
            reliableId,
            '',
            investmentType,
            customData
        );

        return customData.pageName;
    };

    return { doTagRecordPageEvent, doTagRecordPage };
};

export default buildTagging;
